export const steamedStrannaHaspers = {
  id: "steamedStrannaHaspers",
  link: "/#/recipes/recipes/steamedStrannaHaspers",
  name: "Steamed Stranna Haspers",
  cuisine: "Alethi Men's Food",
  summary: "Steamed mussels with a spicy curry sauce",
  inspiration: "Thai curry",
  quantity: "4 servings",
  time: "30 minutes",
  notes:
    "Haspers appear to be a widely eaten food - they're eaten at the very least by the Alethi and Parshendi. I chose to replicate the dish that Adolin ate, as Eshonai's haspers were cooked on the go, so I doubt she had time for an interesting sauce. To make this dish into a Women's Food version, you could omit the gochugaru and add a little honey.",
  quotes:
    "Adolin [finished] an entire plate of stranna haspers steamed in the shell (Oathbringer ch 13)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/haspers-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic"
        },
        {
          item: "ginger",
          display: "1 inch ginger"
        },
        {
          item: "curryPaste",
          display: "2 tbsp yellow curry paste"
        },
        {
          item: "coconut",
          display: "1 cup coconut milk"
        },
        {
          item: "water",
          display: "1/2 cup water"
        },
        {
          item: "turmeric",
          display: "1/2 tsp ground turmeric"
        },
        {
          item: "gochugaru",
          display: "2 tbsp gochugaru"
        },
        {
          iteem: "mussels",
          display: "2 lbs mussels"
        }
      ]
    }
  ],
  steps: [
    "Heat the coconut oil in a pan over medium-high heat. Dice the onion and add it to the pan. Cook until transparent but not yet browned.",
    "Peel and mince the garlic and ginger. Add to the pan, then cook and stir 2 minutes more. Add curry paste and cook and stir until combined.",
    "Add coconut milk, water, turmeric, and gochugaru. Cook and stir until combined.",
    "If using fresh mussels, clean and debeard them. Add the mussels. Stir together until all mussels have been coated in sauce.",
    "Cover and simmer over medium heat. If using fresh mussels, simmer until the mussels open. If using frozen mussels, once the steam starts simmer for the amount of time directed on the package (about 4 minutes). While steaming, swirl the pan around occasionally to continue to coat mussels with sauce.",
    "Serve with flatbread. Any of the flatbread recipes here, or purchased corn tortillas."
  ]
}
